module.exports = __webpack_public_path__ + "static/WPeacePlan-efe5087a53c22b7560d396a0335ef521.jpg";